document.addEventListener('DOMContentLoaded', () => {
    const accordions = document.querySelectorAll('.global-measures-accordion');
    accordions.forEach((accordion) => {
        const button = accordion.querySelector('.accordion-button');
        const content = accordion.querySelector('.accordion-content');
        const contentInner = accordion.querySelector('.accordion-content-inner');
        button.addEventListener('click', () => {
            if (accordion.classList.contains('expanded')) {
                accordion.classList.remove('expanded');
                content.style.height = '0px';
            } else {
                accordion.classList.add('expanded');
                content.style.height = `${contentInner.offsetHeight}px`;
            }
        });
    });
});
